import { RoutePath } from "#src/utils/route";
import { FormsRoute } from "..";

export const linkToFormSchemaList = () => {
  return `/app/forms/templates`;
};

export const FORM_SCHEMA_LIST_BREADCRUMB = {
  title: "Templates",
  path: linkToFormSchemaList,
};

export const FormTemplatesRoute = FormsRoute.concat(
  new RoutePath({
    path: "/templates",
    title: "Templates",
  })
);

export * from "./FormSchemaListPage";
